import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export class CreateQuotation extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path = 'quotation/open/'
  override init: RequestInit = { method: 'POST' }
  override expectedErrors = EXPECTED_ERRORS

  override parseResponse = parseDefiniteQuotationDTO
}
